<template lang="html">
    <div class="default-page-paddings">
        <div class="container container-medium">
            <Heading :title="$t('faq_title')" :routeName="'vignette'" :alignment="'text-left'"></Heading>
            <section class="section-intrebari-frecvente d-flex justify-content-center">
                <FrequentQuestionComponent  :homepage="false" :faqpage="true"></FrequentQuestionComponent>
            </section>
        </div>
    </div>
</template>

<script>

import Heading from './snippets/Heading.vue'
import FrequentQuestionComponent from './FrequentQuestionComponent.vue'

export default {
    name: 'FrequentQuestions',
    components: {
        Heading,
        FrequentQuestionComponent
    },
}

</script>

<style lang="scss" scoped>

    .section-intrebari-frecvente{
        background-color: #FAF9F6;
        padding-top: 50px;
        h2{
            margin-bottom: 20px;
        }
        .intrebare-wrapper{
            width: 100%;
            background-color: #EEEDEC;
            border-radius: 4px;
            padding: 30px 16px;
            position: relative;
            margin-bottom: 20px;
            p{
                margin:0;
                padding-right: 30px;
                &:hover{
                    cursor: pointer;
                }
            }
            &::after{
                content: url('../media/icons/header/ic_sageata.svg');
                position: absolute;
                color: black;
                right: 20px;
                top: 32px;
                width: 15px;
                height: 10px;
                transform: scale(.8) rotate(180deg);
            }
            .question-content{
                display: none;
                padding:10px 25px 10px 0;
            }
        }
        p{

        }
        a{
            padding: 0 16px;
            text-decoration: underline;
            color: #10284B;
            &:hover{
                color: #737880;
            }
        }
    }

    @media only screen and (max-width: 768px) {
        .section-intrebari-frecvente{
            padding-top: 25px;
        }
    }

</style>
